import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              justifyContent: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <h1>مشکلی به وجود آمده است!.</h1>
            <a style={{ fontWeight: "bold", color: "blue" }} href="/">
              بازگشت به صفحه اصلی
            </a>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export { ErrorBoundary };
